export const parseCookies = (cookiesString) => {
    return cookiesString.split(';')
        .map(cookie => cookie.trim().split(/=(.+)/))
        .reduce((acc, [name, value]) => ({ ...acc, [name]: value }), {});
};
